module.exports = __webpack_public_path__ + "static/media/LearnHub.f164945d.jpeg";